module.exports = __webpack_public_path__ + "static/media/pagi-next-page.38b636dd.svg";